export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const VRFYACCTS_REQUEST = 'VRFYACCTS_REQUEST';
export const VRFYACCTS_SUCCESS = 'VRFYACCTS_SUCCESS';
export const VRFYACCTS_FAILURE = 'VRFYACCTS_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const GET_ALL_USER_REQUEST = 'GET_ALL_USER_REQUEST';
export const GET_ALL_USER_SUCCESS = 'GET_ALL_USER_SUCCESS';
export const GET_ALL_USER_FAILURE = 'GET_ALL_USER_FAILURE';

export const CHANGE_USER_PROFILE_REQUEST = 'CHANGE_USER_PROFILE_REQUEST';
export const CHANGE_USER_PROFILE_SUCCESS = 'CHANGE_USER_PROFILE_SUCCESS';
export const CHANGE_USER_PROFILE_FAILURE = 'CHANGE_USER_PROFILE_FAILURE';

export const GET_BUSINESSENTITY_REQUEST = 'GET_BUSINESSENTITY_REQUEST';
export const GET_BUSINESSENTITY_SUCCESS = 'GET_BUSINESSENTITY_SUCCESS';
export const GET_BUSINESSENTITY_FAILURE = 'GET_BUSINESSENTITY_FAILURE';

export const CHG_USER_ROLE_REQUEST = 'CHG_USER_ROLE_REQUEST';
export const CHG_USER_ROLE_SUCCESS = 'CHG_USER_ROLE_SUCCESS';
export const CHG_USER_ROLE_FAILURE = 'CHG_USER_ROLE_FAILURE';

export const SEND_OTP_FRGTP_REQUEST = 'SEND_OTP_FRGTP_REQUEST';
export const SEND_OTP_FRGTP_SUCCESS = 'SEND_OTP_FRGTP_SUCCESS';
export const SEND_OTP_FRGTP_FAILURE = 'SEND_OTP_FRGTP_FAILURE';

export const CHANGE_FRGTP_REQUEST = 'CHANGE_FRGTP_REQUEST';
export const CHANGE_FRGTP_SUCCESS = 'CHANGE_FRGTP_SUCCESS';
export const CHANGE_FRGTP_FAILURE = 'CHANGE_FRGTP_FAILURE';

export const LOGOUT="LOGOUT";